import React, { useState } from 'react';
import { connect } from 'react-redux'
import { Form, FormGroup, Card, CardTitle, CardBody, Row, Col, Button } from 'reactstrap';
import { reduxForm, Field } from 'redux-form';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import 'react-table-6/react-table.css'
import { ToggleField, SectorField, ApplicationTypesField, ApplicationStatusField } from '../../../../components';
import { Utils } from '../../../../services';
import moment from 'moment';

let ApplicationsFilters = ({ application_types, sectors, isLoading, handleSubmit }) => {
    const { t, i18n } = useTranslation();
    const [showFilters, setShowFilters] = useState(true)

    return (
        <Form className="mb-2" onSubmit={handleSubmit}>
            <Card>
                <CardBody>
                    <CardTitle>
                        <i className="fa fa-filter"></i>{t('statstypes.form.filters')}
                        <Button className="btn btn-outline-success float-right" onClick={() => setShowFilters(!showFilters)}><i className={`fa fa-${showFilters ? "minus" : "plus"}`}></i></Button>
                    </CardTitle>
                    {showFilters &&
                    <>
                        <Row>
                            {(application_types?.length > 1) && (
                                <Col xs={12} md={4}>
                                    <FormGroup>
                                        <label>{t("applications.filters.type")}</label><br />
                                        <ApplicationTypesField applicationTypes={application_types} name="types" />
                                    </FormGroup>
                                </Col>
                            )}
                            <Col xs={12} md={4}>
                                <FormGroup>
                                    <label>{t("applications.filters.search")}</label><br />
                                    <Field
                                        component="input"
                                        type="text"
                                        name="search"
                                        placeholder={t('applications.filters.search_placeholder')}
                                        className="form-control"
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={4}>
                                <FormGroup>
                                    <label>{t("applications.filters.status")}</label><br />
                                    <ApplicationStatusField placeholder={t('applications.status_all')} name="status" />
                                </FormGroup>
                            </Col>
                        </Row>
                        <hr className="grey"/>
                        <b className="text-white text-lg">{t('applications.filters.filter_on_shifts')}</b>
                        <Row>
                            <Col xs={12} md={4}>
                                <FormGroup>
                                    <label>{t("applications.filters.having_no_shift")}</label><br />
                                    <ToggleField name="having_no_shift" />
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={4}>
                                <FormGroup>
                                    <label>{t("applications.filters.having_shift")}</label><br />
                                    <ToggleField name="having_shift" />
                                </FormGroup>
                            </Col>
                        </Row>
                        {sectors?.length > 0 && (
                        <>
                            <hr className="grey"/>
                            <b className="text-white text-lg">{t('applications.filters.filter_on_sectors')}</b>
                            <Row>
                                <Col xs={12} md={4}>
                                    <FormGroup>
                                        <label>{t("applications.filters.desired_sectors")}</label><br />
                                        <SectorField sectors={sectors} name="sectors" />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                    <FormGroup>
                                        <label>{t("applications.filters.shifts_in_sectors")}</label><br />
                                        <SectorField sectors={sectors} name="having_shift_in_sectors" />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </>
                        )}
                        <Row>
                            <Col>
                                <Button type="submit" color="success" className="float-right" disabled={isLoading}>
                                    {isLoading ?
                                        <span>
                                            &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                        </span>
                                        :
                                        <span>
                                            {t('statstypes.form.show')}&nbsp;
                                            <i className="fa fa-arrow-circle-right"></i>
                                        </span>
                                    }
                                </Button>
                            </Col>
                        </Row>
                    </>
                    }
                </CardBody>
            </Card>
        </Form>
    )
}

const mapDispatchToProps = {};

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
ApplicationsFilters = reduxForm({
    form: "ApplicationsFilters",
    enableReinitialize: true
})(ApplicationsFilters)

// You have to connect() to any reducers that you wish to connect to yourself
ApplicationsFilters = connect(
    state => ({
        initialValues: state.applications.filters,
        filters: state.applications.filters,
        destroyOnUnmount: false
    }), mapDispatchToProps
)(ApplicationsFilters)

export default ApplicationsFilters
